import '../style.css';
import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

// BulletListItem이 포함되어 있는지 확인하는 헬퍼 함수
const hasBulletListItem = (node: React.ReactNode): boolean => {
    if (!React.isValidElement(node)) return false;
    
    // React.Fragment 또는 div인 경우 children 확인
    const isFragment = node.type === React.Fragment || (typeof node.type === 'symbol');
    if (isFragment || node.type === 'div') {
        const children = React.Children.toArray(node.props?.children || []);
        return children.some(child => {
            if (React.isValidElement(child)) {
                // BulletListItem 컴포넌트인지 확인 (함수명으로 확인)
                const componentName = typeof child.type === 'function' ? child.type.name : String(child.type || '');
                if (componentName.includes('BulletListItem')) return true;
                return hasBulletListItem(child);
            }
            return false;
        });
    }
    
    // 직접 BulletListItem인 경우
    const componentName = typeof node.type === 'function' ? node.type.name : String(node.type || '');
    if (componentName.includes('BulletListItem')) return true;
    
    return false;
};

// 이미 컨테이너 div로 감싸져 있는지 확인
const isAlreadyWrapped = (node: React.ReactNode): boolean => {
    if (!React.isValidElement(node)) return false;
    if (node.type === 'div' && node.props?.style) {
        const style = node.props.style;
        return style.display === 'flex' && style.flexDirection === 'column' && style.gap === '4px';
    }
    return false;
};

export function AboutList (props: {
    companyTitle: React.ReactNode;
    experience: React.ReactNode;
    perieod: React.ReactNode;
    location: React.ReactNode;
}
) {
    // 번역 기능 추가
    const experienceTranslation = useTranslation(typeof props.experience === 'string' ? props.experience : '');
    const locationTranslation = useTranslation(typeof props.location === 'string' ? props.location : '');

    // experience가 BulletListItem을 포함하는지 확인하고, 이미 감싸져 있지 않은 경우에만 감싸기
    const isBulletList = typeof props.experience !== 'string' && hasBulletListItem(props.experience);
    const alreadyWrapped = typeof props.experience !== 'string' && isAlreadyWrapped(props.experience);
    
    // BulletListItem을 포함하지만 아직 감싸지지 않은 경우에만 컨테이너 스타일 적용
    const experienceContent = typeof props.experience === 'string' 
        ? experienceTranslation.translatedText 
        : (isBulletList && !alreadyWrapped)
            ? <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>{props.experience}</div>
            : props.experience;

    return (
        <div className="aboutExperienceList">
            <div className="aboutExperienceListTitle">
                <div className='companyTitle'> {props.companyTitle} </div>
                <div className='location'> 
                    {typeof props.location === 'string' ? locationTranslation.translatedText : props.location} 
                </div>
            </div>
            <div className='experience'>
                {experienceContent}
            </div>
            <div className='period'>{props.perieod}</div>
        </div>
    )
}
